<div class="col" class="file-upload-container">
  <div uploadFile (onFileDropped)="setImage($event);" class="file-box">
    <div *ngIf="imageBase64" class="position-relative">
      <img [src]="exImg ? 'data:image/png;base64,'+exImg : editFiles" class="uploaded-image" />
      <input type="file" id="select-file" style="display:none;" accept="image/png, image/jpeg"
        (change)="setImage($event.target.files);">
      <label for="select-file">
        <i class="fa-solid fa-arrow-up-from-line icon-upload cursor-pointer"></i>
      </label>
    </div>
    <div *ngIf="!imageBase64">
      <div class="position-relative dropped-upload">
        <img src="assets/img/uploadImage.svg" class="default-img">
        <input type="file" id="select-file" style="display:none;" accept="image/png, image/jpeg"
          (change)="setImage($event.target.files);">
        <label for="select-file">
          <i class="fa-solid fa-arrow-up-from-line icon-upload cursor-pointer"></i>
        </label>
      </div>
    </div>
  </div>
</div>
